import React from 'react';
import PageLayout from './PageLayout';

const wrapPageElement = ({ element, props }) => <PageLayout {...props}>{element}</PageLayout>;

export default wrapPageElement;
